import { createApi } from '@reduxjs/toolkit/query/react';
import { auth0BaseQuery } from './auth0BaseQuery';

/**
 * Base API definition for the entire application
 * This will be the single source of truth for API configuration
 * Feature-specific endpoints will be injected into this API
 */
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: auth0BaseQuery,
  tagTypes: [
    // Core entity types go here
    // Feature-specific tags should now be defined in individual feature files
    // using enhanceEndpoints({ addTagTypes: [...] }) instead of here.
    // See src/features/actions/state/actionsApi.ts and
    // src/features/example/state/exampleApi.ts for examples.
  ],
  endpoints: builder => ({
    // You can define shared endpoints here, or leave it empty
    // Most endpoints will be injected by feature modules
    ping: builder.query<{ status: string }, void>({
      query: () => '/ping',
    }),
  }),
});

// Export the hooks for the base API queries
export const { usePingQuery } = baseApi;
